// extracted by mini-css-extract-plugin
module.exports = {"content":"EmployeesBirthdayList_content__2vcGS","label":"EmployeesBirthdayList_label__3iHyN","list":"EmployeesBirthdayList_list__9sco0"};